<template>
  <div>
    <div
      class="row justify-content-center justify-content-sm-between pt-2 row-gutter mb-4"
    >
      <div>
        <div class="card card-modern">
          <div class="card-body">
            <div class="datatables-header-footer-wrapper">
              <div class="datatable-header">
                <div class="row align-items-center mb-3">
                  <div class="col-3 mb-3 mb-lg-0">
                    <router-link
                      class="ecommerce-sidebar-link btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                      :to="{ name: 'AddArticle' }"
                    >
                      + {{ translations.addArticle }}
                    </router-link>
                    <router-link
                      class="ecommerce-sidebar-link btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 mx-2"
                      :to="{ name: 'ImportArticles' }"
                    >
                      + {{ translations.importArticles }}
                    </router-link>
                  </div>
                  <div
                    class="col-9 ps-lg-1 mb-3 mb-lg-0 d-flex justify-content-end align-items-center gap-1"
                  >
                    <treeselect
                      v-model="visibleOnWeb"
                      class="w-25 custom-vue-tree-select"
                      :options="visibleOnWebOptions"
                      placeholder="Izaberite status artikla"
                    />
                    <treeselect
                      v-model="hasImage"
                      class="w-25 custom-vue-tree-select"
                      :options="hasImageOptions"
                      placeholder="Izaberite filter po slici"
                    />
                    <treeselect
                      v-model="articleState"
                      class="w-25 custom-vue-tree-select"
                      :options="articleStates"
                      placeholder="Izaberite stanje artikla"
                    />
                    <treeselect
                      v-model="b2bOrb2c"
                      class="w-25 custom-vue-tree-select"
                      :options="b2bOrb2cOptions"
                      placeholder="B2B/B2C"
                    />
                    <div class="d-flex align-items-lg-center">
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>

                    <div class="search search-style-1 search-style-1-lg">
                      <div class="input-group">
                        <input
                          type="text"
                          class="search-term form-control"
                          placeholder="Search"
                          v-model="searchField"
                          @input="debounceInput"
                        />
                        <button class="btn btn-default" @click="debounceInput">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-gutter-sm mb-5">
      <div class="col-lg-2-5 col-xl-1-5 mb-4 mb-lg-0">
        <div class="filters-sidebar-wrapper bg-light rounded">
          <div class="card card-modern">
            <div class="card-header">
              <div class="card-actions">
                <a
                  class="card-action card-action-toggle"
                  data-bs-toggle="collapse"
                  href="#categories-collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="#categories-collapse"
                ></a>
              </div>
              <h4 class="card-title">KATEGORIJE</h4>
            </div>
            <div class="show" id="categories-collapse">
              <div
                class="card-body hide-scroll"
                style="display: block; max-height: 450px; overflow: auto"
              >
                <!-- <ul class="list list-unstyled mb-0">
                  <li v-for="item in filters.categories" :key="item.categoryId">
                    <a href="#" @click.prevent="categoryId = item.categoryId; brandId = null;">
                      {{ item.category }}
                      <span class="float-end">{{ item.numberOfArticles }}</span>
                    </a>
                  </li>
                </ul> -->

                <tree-view
                  v-for="item in categories"
                  :key="item.id"
                  :item="item"
                  :is-open="false"
                  :selected-id="categoryId"
                  @selected="updateCategoryId"
                />
              </div>
            </div>
          </div>
          <hr class="solid opacity-7" />
          <div class="card card-modern" v-if="priceRange">
            <div class="card-header">
              <div class="card-actions">
                <a
                  class="card-action card-action-toggle"
                  data-bs-toggle="collapse"
                  href="#prices-collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="#prices-collapse"
                ></a>
              </div>
              <h4 class="card-title">CIJENOVNI RANG</h4>
            </div>
            <div class="show" id="prices-collapse">
              <div class="card-body">
                <vue-slider
                  v-if="filters.minPrice !== undefined && filters.maxPrice !== undefined"
                  v-model="priceRange"
                  :min="filters.minPrice"
                  :max="filters.maxPrice"
                  tooltip="hover"
                  :lazy="true"
                />
                <span id="priceRangeValues" class="price-range-values">
                  <span class="min price-range-low">
                    {{ priceRange[0] | money2 }}
                  </span>
                  -
                  <span class="max price-range-high">
                    {{ priceRange[1] | money2 }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="card card-modern">
            <div class="card-header">
              <div class="card-actions">
                <a
                  href="#"
                  class="card-action card-action-toggle"
                  data-card-toggle=""
                ></a>
              </div>
              <h4 class="card-title">SIZES</h4>
            </div>
            <div class="card-body">
              <ul class="list list-inline list-filter mb-0">
                <li class="list-inline-item">
                  <a href="#">S</a>
                </li>
                <li class="list-inline-item">
                  <a href="#" class="active">M</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">L</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">XL</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">2XL</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">3XL</a>
                </li>
              </ul>
            </div>
          </div> -->
          <hr class="solid opacity-7" />
          <div class="card card-modern">
            <div class="card-header">
              <div class="card-actions">
                <a
                  class="card-action card-action-toggle"
                  data-bs-toggle="collapse"
                  href="#brands-collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="#brands-collapse"
                ></a>
              </div>
              <h4 class="card-title">BRENDOVI</h4>
            </div>
            <div class="show" id="brands-collapse">
              <div class="card-body">
                <ul class="list list-unstyled mb-0">
                  <li v-for="item in filters.brands" :key="item.brandId">
                    <a
                      href="#"
                      @click.prevent="
                        brandId = item.brandId;
                        categoryId = null;
                      "
                      >{{ item.brand }}
                      <span class="float-end">{{ item.numberOfArticles }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3-5 col-xl-4-5">
        <div class="row row-gutter-sm" v-if="articles.length > 0">
          <div
            class="col-sm-6 col-xl-3 mb-3"
            v-for="article in articles"
            :key="article.id"
          >
            <div class="card card-modern card-modern-alt-padding">
              <div class="card-body bg-light">
                <div class="image-frame mb-2">
                  <div class="image-frame-wrapper">
                    <router-link
                      :to="{ name: 'EditArticle', params: { id: article.id } }"
                    >
                      <photo
                        :src="'img/products/product-8.jpg'"
                        v-if="!article.highlightedImageUrl"
                      />
                      <photo
                        :src="`'${baseUrl}${article.highlightedImageUrl}'`"
                        v-else
                      />
                    </router-link>
                  </div>
                </div>
                <small>
                  <router-link
                    v-if="article.categoryId"
                    :title="article.category"
                    class="ecommerce-sidebar-link text-color-grey text-color-hover-primary text-decoration-none text-hidden"
                    :to="{
                      name: 'EditCategory',
                      params: { id: article.categoryId },
                    }"
                  >
                    {{ article.category }}
                  </router-link>
                  <div v-else class="text-hidden" :title="article.category">
                    {{ article.category }}
                  </div>
                </small>
                <h4 class="text-4 line-height-2 mt-0 mb-2">
                  <router-link
                    class="ecommerce-sidebar-link text-color-dark text-color-hover-primary text-decoration-none text-hidden"
                    :title="article.title"
                    :to="{ name: 'EditArticle', params: { id: article.id } }"
                  >
                    {{ article.title }}
                  </router-link>
                  <div>
                    {{ article.code }}
                  </div>
                </h4>
                <div class="stars-wrapper">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <div class="product-price">
                  <!-- <div class="regular-price on-sale">${{ article.nc.toFixed(2) }}</div> -->
                  <div class="sale-price">{{ article.vpc | money2 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="alert alert-info" role="alert">
            {{ translations.noRecords }}
            <a class="alert-link" @click.prevent="resetFilters">{{
              translations.resetFilters
            }}</a
            >.
          </div>
        </div>
        <div class="row row-gutter-sm justify-content-between mt-4">
          <pagination
            :action="actionName"
            :pagination-props="paginationProps"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-range-component';
import 'vue-range-component/dist/vue-range-slider.css';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import config from '@/config';
import helpers from '@/services/helpers';

import { translations, pager } from '@/mixins';

import Pagination from '../shared/Pagination.vue';
import Photo from '../shared/Photo.vue';
import TreeView from '../shared/tree-view/TreeView.vue';

export default {
  name: 'Articles',
  components: {
    Treeselect,
    VueSlider,
    Pagination,
    Photo,
    TreeView,
  },
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getArticles',
      baseUrl: config.baseUrl,
      categoryId:
        query?.categoryId && query?.categoryId !== 'null'
          ? parseInt(query.categoryId, 10)
          : null,
      brandId:
        query?.brandId && query?.brandId !== 'null'
          ? parseInt(query.brandId, 10)
          : null,
      articleState:
        query?.articleState && query?.articleState !== 'null'
          ? parseInt(query.articleState, 10)
          : null,
      visibleOnWeb:
        query?.visibleOnWeb && query?.visibleOnWeb !== 'null'
          ? !!query.visibleOnWeb
          : null,
      hasImage:
        query?.hasImage && query?.hasImage !== 'null'
          ? !!query?.hasImage
          : null,
      priceRange:
        query?.minPrice && query?.maxPrice
          ? [parseFloat(query?.minPrice, 10), parseFloat(query?.maxPrice, 10)]
          : null,
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
    };
  },
  computed: {
    articles() {
      return this.$store.getters.getArticles;
    },
    articleStates() {
      return helpers.articleStates;
    },
    visibleOnWebOptions() {
      return [
        { id: true, label: 'Aktivan' },
        { id: false, label: 'Neaktivan' },
      ];
    },
    hasImageOptions() {
      return [
        { id: true, label: 'Artikal ima sliku' },
        { id: false, label: 'Artikal nema sliku' },
      ];
    },
    b2bOrb2cOptions() {
      return [
        { id: 'b2b', label: 'B2B' },
        { id: 'b2c', label: 'B2C' },
        { id: 'all', label: 'Sve' },
      ];
    },
    filters() {
      return this.$store.getters.getArticleFilters;
    },
    paginationProps() {
      return {
        categoryId: this.categoryId,
        brandId: this.brandId,
        categoryIds: this.categoryId
          ? [this.categoryId, ...this.childCategoryIds]
          : [],
        brandIds: this.brandId ? [this.brandId] : [],
        quickSearch: this.$route.query.search || this.searchConfig.quickSearch,
        articleState: this.articleState,
        visibleOnWeb: this.visibleOnWeb,
        hasImage: this.hasImage,
        minPrice: this.priceRange?.[0],
        maxPrice: this.priceRange?.[1],
        b2b: this.b2bOrb2c === 'b2b' ? true : null,
        b2c: this.b2bOrb2c === 'b2c' ? true : null,
      };
    },
    categories() {
      const getCategoriesTreeView = (categories) => {
        function generateTree(categories, parentId = null) {
          const tree = [];
          categories
            .filter((category) => category.parentCategoryId === parentId)
            .forEach((category) => {
              const node = {
                id: category.id,
                label: category.title,
                numberOfArticles: category.numberOfArticles,
                parentCategoryId: category.parentCategoryId,
                children: generateTree(categories, category.id),
              };
              tree.push(node);
            });
          return tree;
        }

        return generateTree(categories, null);
      };

      const sortMethod = (a, b) => a.order - b.order;

      const categories = [...(this.filters?.categories || [])].sort(sortMethod);

      return getCategoriesTreeView(categories);
    },
    childCategoryIds() {
      return this.$store.getters.getChildrenCategoryIds(this.categoryId);
    },
  },
  methods: {
    updateCategoryId(id) {
      this.categoryId = id;
      this.brandId = null;
    },
    getArticles() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  mounted() {
    const { query } = this.$route;

    this.$store.dispatch(this.actionName, {
      ...this.searchConfig,
      ...this.paginationProps,
      page: query?.page ? parseInt(query.page, 10) : 1,
    });
    this.$store.dispatch('getArticleFilters').then(({ minPrice, maxPrice }) => {
      this.$nextTick(() => {
        if (!this.priceRange) {
          this.priceRange = [minPrice, maxPrice];
        } else {
          this.priceRange = [
            Math.max(this.priceRange[0], minPrice),
            Math.min(this.priceRange[1], maxPrice),
          ];
        }
      });
    });
  },
  watch: {
    categoryId() {
      this.getArticles();
    },
    brandId() {
      this.getArticles();
    },
    articleState() {
      this.getArticles();
    },
    visibleOnWeb() {
      this.getArticles();
    },
    hasImage() {
      this.getArticles();
    },
    priceRange(newVal, oldVal) {
      if (newVal?.[0] !== oldVal?.[0] || newVal?.[1] !== oldVal?.[1]) {
        this.getArticles();
      }
    },
    b2bOrb2c() {
      this.getArticles();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-hidden {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.hide-scroll {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.hide-scroll::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
</style>
<style lang="scss">
.vue-treeselect {
  min-height: 47px;
}

.vue-treeselect__control {
  min-height: 47px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}

.vue-treeselect__value-container {
  min-height: 47px;
}

.results-per-page {
  min-width: 60px;
}

</style>
